import React, { useState, useEffect, useRef } from 'react';
import { useRequest } from 'umi';
import { Modal, Image, QRCode, message } from 'antd';
import Echarts from './echarts';
import styles from '@/pages/camp/components/css/campCSS.less';
import wufanHotPng from '@/static/images/wufan_hot.png';
import hotPng from '@/static/images/hot.png';
import cx from 'classnames';
import { StudyReportVO } from '@/types/camp/study/studentBaseInfoType';
import { getStudyReport } from '@/utils/requests/camp/requests_study';
import { StudyInfoType } from '@/types/camp/study/studentBaseInfoType';
import { formatDuration } from '@/pages/camp/util/indexUtil';
import { getProductNamesByIds } from '@/types/camp/campIndex/indexTypes';
import html2canvas from 'html2canvas';

interface Props {
  studentInfo: StudyInfoType;
  open: boolean;
  setOpen: (open: boolean) => void;
}
const StudyReport: React.FC<Props> = ({ studentInfo, open, setOpen }) => {
  const [data, setData] = useState<StudyReportVO>();
  const [isShowMinNode, setIsShowMinNode] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);
  const downloadLinkRef = useRef<HTMLAnchorElement>(null);

  // 导出报告
  const handleCaptureClick = async () => {
    if (elementRef.current) {
      // 隐藏具有特定类名的元素
      const elementsToHide = elementRef.current.querySelectorAll(
        '.hide_download_dom',
      ) as NodeListOf<HTMLElement>;
      elementsToHide.forEach((el) => {
        el.style.display = 'none';
      });

      try {
        const canvas = await html2canvas(elementRef.current, { scale: 4, useCORS: true });
        const imgData = canvas.toDataURL('image/png');

        // 设置下载链接的 href 属性为图片数据
        if (downloadLinkRef.current) {
          const event = new MouseEvent('click');
          const a = document.createElement('a');
          a.href = imgData;
          a.download = 'ExclusiveHonorPoster.png';
          document.body.appendChild(a);
          a.dispatchEvent(event);
          document.body.removeChild(a);
          message.success('个人专属荣誉海报已成功生成并下载！');
        }
      } catch (error) {
        // 弹出错误消息
        message.error('生成个人专属荣誉海报失败，请重试！');
      } finally {
        // 捕获完成后，重新显示之前隐藏的元素
        elementsToHide.forEach((el) => {
          el.style.display = '';
        });
      }
    }
  };

  // 获取接口
  const { run: getStudyReportRequest } = useRequest(
    () => {
      return getStudyReport(studentInfo.batchId);
    },
    {
      manual: true,
      onSuccess: (res) => {
        setData(res);
      },
    },
  );
  useEffect(() => {
    open && getStudyReportRequest();
  }, [open]);

  useEffect(() => {
    data &&
      data.studyNodeList.map((item) => {
        if (item.totalNodeScore && item.totalNodeScore !== 0) {
          let valueList = parseFloat(((item.actualScore / item.totalNodeScore) * 100).toFixed(0)); // 转换为浮点数
          console.log('valueList', valueList);
          if (valueList < 100) {
            setIsShowMinNode(true);
          }
        }
      });
  }, [data]);

  return (
    <Modal
      title={''}
      wrapClassName={styles.study_report_modal}
      open={open}
      destroyOnClose={true}
      centered
      width={720}
      onOk={() => {}}
      onCancel={() => {
        setOpen(false);
      }}
      footer={null}
    >
      {data && (
        <div className={styles.study_report_content} style={{ minHeight: 300 }} ref={elementRef}>
          <div className="flex_3">
            <div>
              <div className="f18 flex_1">
                <span className="f18">恭喜你，{data.realName ? data.realName : data.username}</span>
                <img src={hotPng} width={30} style={{ margin: '-10px 0 0 6px' }} />
              </div>
              <div className="f24" style={{ lineHeight: 1.2 }}>
                {studentInfo.camp.name}
              </div>
            </div>
            <div className="flex_0" style={{ alignItems: 'flex-end', paddingRight: 20 }}>
              <img src={wufanHotPng} width={172} height={100} />
            </div>
          </div>

          <div className={styles.my_card}>
            <div className={styles.lf}>
              <div className="f20 fw600 mb10">学习成果</div>
              <div>
                亲爱的{' '}
                <span className="col008">{data.realName ? data.realName : data.username}</span>
                ，恭喜您完成{' '}
                <span className="col008">
                  {studentInfo.batch.name}《{studentInfo.camp.name}》
                </span>
                ，在本次训练营中，您表现出色，仅用
                {formatDuration(studentInfo.learningDuration, { showS: false })}
                就完成了所有学习任务，您在本期学习中的得分高达
                <span className="colff7"> {studentInfo.campScore} </span>分，在本期学员中排名第
                <span className="colff7"> {data.myRanking} </span>名。
              </div>
            </div>
            <div className={styles.rt}>
              <div className={styles.card_item_box}>
                <div className={styles.card_item}>
                  <div className="f12 col808">总学习时长</div>
                  <div className="f16 col008">
                    {formatDuration(studentInfo.learningDuration, { showS: false })}
                  </div>
                </div>
                <div className={styles.card_item}>
                  <div className="f12 col808">习题正确率</div>
                  <div>
                    <span className="f16 col00c">
                      {data.correctQuestion &&
                        data.totalQuestion &&
                        ((data.correctQuestion / data.totalQuestion) * 100).toFixed(1)}
                      %
                    </span>
                    <span
                      className="f12 col808"
                      style={{ marginLeft: 4 }}
                    >{`(${data.correctQuestion}/${data.totalQuestion})`}</span>
                  </div>
                </div>
                <div className={styles.card_item}>
                  <div className="f12 col808">日均学习时长</div>
                  <div className="f16 col008">
                    {data.studyDays &&
                      formatDuration(Math.floor(studentInfo.learningDuration / data.studyDays), {
                        showS: false,
                      })}
                  </div>
                </div>
                <div className={styles.card_item}>
                  <div className="f12 col808">心得被精选</div>
                  <div className="f16 colff7">{data.selectedNumber} 次</div>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.my_card}>
            <div className={styles.lf} style={{ margin: '-10px 0px 0 -10px', height: 286 }}>
              <Echarts data={data} campName={studentInfo.camp.name} />
            </div>
            <div className={cx(styles.rt, 'flex_4_2')}>
              <span className="f20 fw600" style={{ marginBottom: 12 }}>
                学习突出亮点
              </span>
              <div className="flex_4_2" style={{ gap: 14 }}>
                <div className={styles.card_text_list}>
                  在打卡学习期间，您在 <span className="colff7">{data.maxNodeScoreName}</span>{' '}
                  打卡学习中取得优异成绩，表现突出。
                </div>
                {isShowMinNode && (
                  <div className={styles.card_text_list}>
                    同时您在 <span className="col008">{data.minNodeScoreName}</span>{' '}
                    的打卡学习还有待加强。
                  </div>
                )}
                {data.checkDynamic && data.checkDynamicSelected && (
                  <div className={styles.card_text_list}>
                    您多次留下心得和其他用户进行交流互动，并且心得被选为精选内容，给多位小伙伴带来学习启发。
                  </div>
                )}
                {data.checkDynamic && !data.checkDynamicSelected && (
                  <div className={styles.card_text_list}>
                    您多次留下心得和其他用户进行交流互动，给多位小伙伴带来学习启发。
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className={styles.my_card}>
            <div className={styles.lf}>
              <div className="f20 fw600 mb10">本期荣誉</div>

              {/* 有认证且为优秀学员 */}
              {data.certStudyNode && data.certificate.type === 2 && (
                <div>
                  太棒了！你不仅把 <span className="colff7">{data.certStudyNode.certName} </span>{' '}
                  证书收入囊中，还荣获了
                  <span className="colff7">优秀学员</span> 的称号，真是光彩夺目！
                  这张证书，不仅仅是对你勤奋学习的官方认证，更是对你不屈不挠、始终如一努力的超级大赞！然而，学习的旅程永不止步，结营并不代表结束，而是一个新的起点。[
                  {getProductNamesByIds(studentInfo.camp.product)}
                  ]的应用多样而广泛，希望你们能够在今后的工作和学习中继续发挥所学，不断探索，不断创新。
                </div>
              )}

              {/* 无认证且为优秀学员 */}
              {!data.certStudyNode && data.certificate.type === 2 && (
                <div>
                  太棒了！你荣获了<span className="colff7">【优秀学员】</span>的称号，真是光彩夺目！
                  这张证书不仅仅是对你勤奋学习的官方认证，更是对你不屈不挠、始终如一努力的超级大赞！然而，学习的旅程永不止步，结营并不代表结束，而是一个新的起点。[
                  {getProductNamesByIds(studentInfo.camp.product)}
                  ]的应用多样而广泛，希望你们能够在今后的工作和学习中继续发挥所学，不断探索，不断创新。
                </div>
              )}

              {/* 无认证且普通学员 */}
              {!data.certStudyNode && data.certificate.type === 1 && (
                <div>
                  太棒了！你成功完成打卡营并获得了结营证书，这张证书不仅仅是对你勤奋学习的官方认证，更是对你不屈不挠、始终如一努力的超级大赞！。然而，学习的旅程永不止步，结营并不代表结束，而是一个新的起点。[
                  {getProductNamesByIds(studentInfo.camp.product)}
                  ]的应用多样而广泛，希望你们能够在今后的工作和学习中继续发挥所学，不断探索，不断创新。
                </div>
              )}
            </div>
            <div className={styles.rt}>
              <div>
                {data.certificate.url ? (
                  <Image
                    src={
                      data.certificate.outstandingUrl
                        ? data.certificate.outstandingUrl
                        : data.certificate.url
                    }
                    width={266}
                    crossOrigin="anonymous"
                  />
                ) : (
                  <div
                    className="col808"
                    style={{
                      backgroundColor: '#D1E9FF',
                      width: 266,
                      height: 154,
                      textAlign: 'center',
                      paddingTop: 40,
                    }}
                  >
                    暂无证书
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.my_card}>
            <div className="flex_1">
              <div>
                <QRCode
                  bordered={false}
                  size={100}
                  value={`${process.env.EDU_URL}/v2/camp/${studentInfo.cardCampId}?from=share&uid=${studentInfo.createdBy}`}
                />
              </div>
              <div className="f16" style={{ marginLeft: 24 }}>
                <p>
                  我已在<span className="col008">《{studentInfo.camp?.name}》 </span>中和
                  <span style={{ padding: '0 6px' }}>{studentInfo.allStudent}</span>
                  位小伙伴一起学习，邀请你和我一起免费参加～
                </p>
                <p>扫描左侧二维码立即报名。</p>
              </div>
            </div>
          </div>
          <div
            className="hide_download_dom"
            style={{
              width: 720,
              marginLeft: -24,
              marginTop: 32,
              position: 'sticky',
              borderTop: '1px solid #D6DFE7',
              backgroundColor: '#dbf2ff',
              padding: '12px 24px',
              bottom: 0,
            }}
          >
            <div
              className="com_camp_btn f16"
              onClick={handleCaptureClick}
              style={{
                height: 40,
              }}
            >
              {studentInfo.camp?.finishRule?.downloadReportBtnText
                ? studentInfo.camp.finishRule.downloadReportBtnText
                : '立即生成个人专属荣誉海报'}
            </div>
          </div>
          <a ref={downloadLinkRef} style={{ display: 'none' }}></a>
        </div>
      )}
    </Modal>
  );
};
export default StudyReport;
